/* global $ */
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'
import './swiper.css'

function init () {
  $(document).ready(function () {
    // initialize swiper when document ready
    const swiperElem = $('.swiper-container.hero-swiper')
    if (swiperElem.length === 0) {
      return
    }
    let loopVal = false
    if ($(swiperElem).find('.swiper-slide').length > 1) {
      // loop only if swiper has more than 1 slide
      loopVal = true
    }
    const swiper = new Swiper(swiperElem[0], {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      fadeEffect: {
        crossFade: true
      },
      effect: 'fade',
      speed: 2000,
      loop: loopVal,
      watchOverflow: true,
      autoHeight: false,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true
      },
      pagination: {
        el: $(swiperElem).find('.swiper-pagination')[0],
        clickable: true
      },
      navigation: {
        nextEl: $(swiperElem).find('.swiper-button-next')[0],
        prevEl: $(swiperElem).find('.swiper-button-prev')[0]
      }
    })
    swiper.init()
  })
}

export default {
  init
}
